module.exports = __webpack_public_path__ + "fonts/Poppins-ThinItalic.01555d25.ttf";